import type { AppThunk } from "@Store/index";
import getNewsHomeData from "../NewsHome/data/getNewsHomeData";
import { fetchNewsPageDataIfNeeded } from "../NewsPost/data/newsPageReducer";

/**
 * Centralized loadData function for all news pages.
 * Handles news home, category, tag, search, latest, and individual news posts
 * (including /news/amberreport/:slug and /news/amberbeat/:slug).
 */
const loadData = (props: any): AppThunk[] => {
  const path = __SERVER__ ? props?.req?.path : window.location.pathname;
  const queryString = __SERVER__ ? props?.req?.query : new URLSearchParams(window.location.search);

  // News home page
  if (path === "/news") {
    return [getNewsHomeData({ staticContext: props?.staticContext })];
  }

  // Determine page type from URL
  const isCategory = path.includes("/category/");
  const isTag = path.includes("/tag/");
  const isLatest = path.includes("/latest");
  const isSearch = path.includes("/search");
  const searchQuery = __SERVER__
    ? queryString?.query || queryString?.q || ""
    : queryString.get("query") || queryString.get("q") || "";

  return [fetchNewsPageDataIfNeeded(props, isCategory, isTag, isSearch, searchQuery, isLatest)];
};

export default loadData;
